import { Box } from "@mui/material";
import React from "react";

type TaskIconBadgeProps = {
    icon: React.ReactNode;
    color: string;
    backgroundColor: string;
};

export const TaskIconBadge = ({
    icon,
    color,
    backgroundColor,
}: TaskIconBadgeProps) => {
    return (
        <Box
            data-testid="task-icon-badge"
            style={{ backgroundColor, color }}
            sx={{
                width: 24,
                height: 24,
                borderRadius: "5px",
                padding: "3px",
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                },
            }}
        >
            {icon}
        </Box>
    );
};
